/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EFormePersonne } from './EFormePersonne';
import {
    EFormePersonneFromJSON,
    EFormePersonneFromJSONTyped,
    EFormePersonneToJSON,
} from './EFormePersonne';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { EListSearchTypeEFormePersonneCombinableCriteria } from './EListSearchTypeEFormePersonneCombinableCriteria';
import {
    EListSearchTypeEFormePersonneCombinableCriteriaFromJSON,
    EListSearchTypeEFormePersonneCombinableCriteriaFromJSONTyped,
    EListSearchTypeEFormePersonneCombinableCriteriaToJSON,
} from './EListSearchTypeEFormePersonneCombinableCriteria';

/**
 * 
 * @export
 * @interface EFormePersonneListSearch
 */
export interface EFormePersonneListSearch {
    /**
     * 
     * @type {Array<EListSearchTypeEFormePersonneCombinableCriteria>}
     * @memberof EFormePersonneListSearch
     */
    criterias?: Array<EListSearchTypeEFormePersonneCombinableCriteria> | null;
    /**
     * 
     * @type {EListSearchType}
     * @memberof EFormePersonneListSearch
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {EFormePersonne}
     * @memberof EFormePersonneListSearch
     */
    value?: EFormePersonne;
    /**
     * 
     * @type {EFormePersonne}
     * @memberof EFormePersonneListSearch
     */
    secondaryValue?: EFormePersonne;
    /**
     * 
     * @type {Array<string>}
     * @memberof EFormePersonneListSearch
     */
    readonly availableSearchTypes?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof EFormePersonneListSearch
     */
    defaultSearchType?: string | null;
}

/**
 * Check if a given object implements the EFormePersonneListSearch interface.
 */
export function instanceOfEFormePersonneListSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EFormePersonneListSearchFromJSON(json: any): EFormePersonneListSearch {
    return EFormePersonneListSearchFromJSONTyped(json, false);
}

export function EFormePersonneListSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): EFormePersonneListSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criterias': !exists(json, 'criterias') ? undefined : (json['criterias'] === null ? null : (json['criterias'] as Array<any>).map(EListSearchTypeEFormePersonneCombinableCriteriaFromJSON)),
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : EFormePersonneFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : EFormePersonneFromJSON(json['secondaryValue']),
        'availableSearchTypes': !exists(json, 'availableSearchTypes') ? undefined : json['availableSearchTypes'],
        'defaultSearchType': !exists(json, 'defaultSearchType') ? undefined : json['defaultSearchType'],
    };
}

export function EFormePersonneListSearchToJSON(value?: EFormePersonneListSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criterias': value.criterias === undefined ? undefined : (value.criterias === null ? null : (value.criterias as Array<any>).map(EListSearchTypeEFormePersonneCombinableCriteriaToJSON)),
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': EFormePersonneToJSON(value.value),
        'secondaryValue': EFormePersonneToJSON(value.secondaryValue),
        'defaultSearchType': value.defaultSearchType,
    };
}

